let Fingerprint
if (!Fingerprint) {
  if (
    typeof window !== "undefined" &&
    typeof window.Fingerprint !== "undefined"
  ) {
    Fingerprint = window.Fingerprint;
  }
}

class BetterSet extends Set {
  clone() {
    return new BetterSet(this);
  }

  map(transformfn) {
    const response = new BetterSet();

    for (const [key, value] of this.entries()) {
      response.add(transformfn(value, key, this));
    }

    return response;
  }

  filter(filterfn) {
    const response = new BetterSet();

    for (const [key, value] of this.entries()) {
      if (filterfn(value, key, this)) {
        response.add(value);
      }
    }

    return response;
  }

  toArray() {
    return Array.from(this);
  }
}

// const { Base64, Utf8 } = PGSDPCore;
const { WebApi, SampleFormat } = Fingerprint;

class DeviceEvent extends Event {
  constructor(type, deviceId) {
    if (type === "Connected") {
      super("onDeviceConnected");
    } else if (type === "Disconnected") {
      super("onDeviceDisconnected");
    }else {
      super("unkown");
    }

    this.deviceId = deviceId;
  }
}

class DeviceListEvent extends Event {
  constructor(type) {
    if (type === "Empty") {
      super("onNoDevices");
    } else if (type === "Filled") {
      super("onDevices");
    } else {
      super("unkown");
    }
  }
}

class FingerPrintEvent extends Event {
  constructor(fp) {
    super("onFingerPrint");
    this.fp = fp;
  }
}

class FingerSignalError extends Event {
  constructor(error) {
    super("onError");
    this.error = error;
  }
}

class FingerReaderSignals extends EventTarget {
  constructor(sampleFormat) {
    super();
    this.reader = null;
    this.connectedReaders = null;
    this.scanInterval = null;
    this.sampleFormat = sampleFormat;
  }

  async init() {
    if (this.reader === null) {
      this.reader = new WebApi();
      this.connectedReaders = new BetterSet();

      this.reader.onDeviceConnected = this.onDeviceConnected.bind(this);
      this.reader.onDeviceDisconnected = this.onDeviceDisconnected.bind(this);
      this.reader.onSamplesAcquired = this.onSamplesAcquired.bind(this);
      this.reader.onCommunicationFailed = this.onCommunicationFailed.bind(this);
      // this.reader.onQualityReported = this.logEvent.bind(this);

      this.scanInterval = setInterval(async () => {
        try {
          const readers = await this.reader.enumerateDevices();
          const lastKnownConnectedReaders = new Set(this.connectedReaders);
          for (const reader of readers) {
            if (!this.connectedReaders.has(reader)) {
              const devInfo = await this.reader.getDeviceInfo(reader);
              if (devInfo.eDeviceTech === 1) {
                await this.reader.startAcquisition(this.sampleFormat, reader);
              }
            }
            lastKnownConnectedReaders.delete(reader);
          }
        } catch (err) {
          // console.log(err)
          // this.dispatchEvent(new FingerSignalError(err));
        }
      }, 2000);
    }
  }

  async pauseAcquisition() {
    await Promise.all(
      this.connectedReaders
        .map((reader) => this.reader.stopAcquisition(reader))
        .toArray()
    );
  }

  async resumeAcquisition() {
    await Promise.all(
      this.connectedReaders
        .map((reader) =>
          this.reader.startAcquisition(this.sampleFormat, reader)
        )
        .toArray()
    );
  }

  async onDeviceConnected(e) {
    const deviceUid = e.deviceUid;
    // SINGLE READER LISTENER
    if (!this.connectedReaders.has(deviceUid)) {
      this.connectedReaders.add(deviceUid);
      this.dispatchEvent(new DeviceEvent("Connected", deviceUid));
    }

    if (this.connectedReaders.size > 0) {
      this.dispatchEvent(new DeviceListEvent("Filled"));
    }
  }

  async onDeviceDisconnected(e) {
    const deviceUid = e.deviceUid;

    // SINGLE READER LISTENER
    if (this.connectedReaders.has(deviceUid)) {
      this.connectedReaders.delete(deviceUid);
      await this.reader.stopAcquisition(deviceUid);
      this.dispatchEvent(new DeviceEvent("Disconnected", deviceUid));
    }

    if (this.connectedReaders.size <= 0) {
      this.dispatchEvent(new DeviceListEvent("Empty"));
    }
  }

  async onSamplesAcquired(e) {
    
    if (this.sampleFormat === SampleFormat.Raw) {
      const samples = JSON.parse(e.samples);
      const vendor = samples[0].Header.Format.FormatOwner;
      // Decode the raw data from the base format of Base64URL to Base64
      const sampleData = Fingerprint.b64UrlTo64(samples[0].Data);
      // Parse the JSON fromBase64URL to Utf8, this to get the correct format that DP SDK use to create the FMD
      const decodedData = JSON.parse(Fingerprint.b64UrlToUtf8(sampleData));
      // las transform to send as base 64
      const sendData = Fingerprint.b64UrlTo64(decodedData.Data);

      const quality = {
        dpi: decodedData.Format.iXdpi,
        height: decodedData.Format.iHeight,
        width: decodedData.Format.iWidth,
      };
      

      this.dispatchEvent(
        new FingerPrintEvent({
          Format: this.sampleFormat,
          Quality: quality,
          Data: sendData,
          Vendor: vendor,
        })
      );
    } else if (this.sampleFormat === SampleFormat.Intermediate) {
      const samples = JSON.parse(e.samples);
      const sampleData = Fingerprint.b64UrlTo64(samples[0].Data);
      

      this.dispatchEvent(
        new FingerPrintEvent({
          Format: this.sampleFormat,
          Data: sampleData,
        })
      );
    } else {
      this.dispatchEvent(
        new FingerSignalError(new Error("Invalid SampleError"))
      );
    }
  }

  async onCommunicationFailed(e){
    this.dispatchEvent(new FingerSignalError(new Error("Error de comunicacion")));
  }

  async readFingerPrint() {
    return new Promise((res, rej) => {
      const cb = (e) => {
        try {
          res(e);
          this.removeEventListener("onFingerPrint", cb);
        } catch (err) {
          rej(err);
        }
      };

      this.addEventListener('onFingerPrint', cb)
    });
  }

  async destroy() {
    clearInterval(this.scanInterval);
    const tasks = this.connectedReaders.map(async (uid) => {
      await this.reader.stopAcquisition(uid);
    });
    await Promise.all(tasks.toArray());
    this.connectedReaders.clear();
    delete this.connectedReaders;
    delete this.reader;

    this.reader = null;
    this.connectedReaders = null;
    this.scanInterval = null;
  }
  
  
  
  async logEvent(e) {
    console.log(e);
  }
}

FingerReaderSignals.SampleFormats = {
  Raw: SampleFormat.Raw,
  Intermediate: SampleFormat.Intermediate,
};
export { FingerReaderSignals };